import ActivityBuilder from "./builder/ActivityBuilder";

const AdminActivityWizard = (props) => (
  <ActivityBuilder {...props} isAdmin />
);

export default AdminActivityWizard;
